<!--
 * @Author: zhaowh zhaowh@example.com
 * @Date: 2023-09-15 17:00:29
 * @LastEditors: zhaowh zhaowh@example.com
 * @LastEditTime: 2023-09-15 17:02:10
-->
<template>
    <router-view />
</template>

<script>
export default {
	name: 'ProductView',
};
</script>